import {
  getPaymentConditionTableByIdQuery,
  getAllPaymentConditionTablesQuery,
  getAllPaymentMethodsQuery,
  getAllContactMethodsQuery,
  createPaymentMethodMutation,
  updatePaymentMethodMutation,
  deletePaymentMethodMutation,
  createPaymentConditionTableMutation,
  updatePaymentConditionTableMutation,
  deletePaymentConditionTableMutation,
  createContactMethodMutation,
  updateContactMethodMutation,
  deleteContactMethodMutation
} from '~src/graphql/payments.graphql'

export default {
  getAllPaymentMethods({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      modelName: 'paymentMethods',
      loader: 'paymentMethods:get',
      query: getAllPaymentMethodsQuery,
      resultPath: 'paymentMethods.nodes'
    })
  },
  getAllPaymentConditionTables({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      modelName: 'paymentConditionTables',
      loader: 'paymentConditionTables:get',
      query: getAllPaymentConditionTablesQuery,
      resultPath: 'paymentConditionTables.nodes'
    })
  },
  getPaymentConditionByTableById({ state, dispatch }, tableId) {
    return dispatch('getItemById', {
      id: tableId,
      state,
      modelName: 'selectedPaymentConditionTable',
      loader: 'paymentConditionTable:get',
      query: getPaymentConditionTableByIdQuery,
      resultPath: 'paymentConditionTable'
    })
  },
  getAllContactMethods({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      modelName: 'contactMethods',
      loader: 'contactMethods:get',
      query: getAllContactMethodsQuery,
      resultPath: 'contactMethods.nodes'
    })
  },
  setSelectedPaymentConditionTable({ state, commit }, paymentConditionTable) {
    commit('SET_ITEM', {
      item: paymentConditionTable,
      state,
      modelName: 'selectedPaymentConditionTable'
    })
  },
  // CRUD
  // Payment Method
  createPaymentMethod({ state, dispatch }, paymentMethod) {
    return dispatch('createItem', {
      item: { paymentMethod },
      state,
      addTo: ['paymentMethods'],
      loader: 'paymentMethod:create',
      mutation: createPaymentMethodMutation,
      resultPath: 'createPaymentMethod.paymentMethod'
    })
  },
  updatePaymentMethod({ state, dispatch }, paymentMethod) {
    return dispatch('createItem', {
      item: paymentMethod,
      state,
      addTo: ['paymentMethods'],
      loader: 'paymentMethod:update',
      mutation: updatePaymentMethodMutation,
      resultPath: 'updatePaymentMethod.paymentMethod'
    })
  },
  deletePaymentMethod({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['paymentMethods'],
      loader: 'paymentMethod:delete',
      mutation: deletePaymentMethodMutation
    })
  },
  // Payment Method Table
  createPaymentConditionTable({ state, dispatch }, paymentConditionTable) {
    return dispatch('createItem', {
      item: { paymentConditionTable },
      state,
      addTo: ['paymentConditionTables'],
      loader: 'paymentConditionTable:create',
      mutation: createPaymentConditionTableMutation,
      resultPath: 'createPaymentConditionTable.paymentConditionTable'
    })
  },
  updatePaymentConditionTable({ state, dispatch }, paymentConditionTable) {
    return dispatch('createItem', {
      item: paymentConditionTable,
      state,
      addTo: ['paymentConditionTables'],
      loader: 'paymentConditionTable:update',
      mutation: updatePaymentConditionTableMutation,
      resultPath: 'updatePaymentConditionTable.paymentConditionTable'
    })
  },
  deletePaymentConditionTable({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['paymentConditionTables'],
      loader: 'paymentConditionTable:delete',
      mutation: deletePaymentConditionTableMutation
    })
  },
  // Contact Method
  createContactMethod({ state, dispatch }, contactMethod) {
    return dispatch('createItem', {
      item: { contactMethod },
      state,
      addTo: ['contactMethods'],
      loader: 'contactMethod:create',
      mutation: createContactMethodMutation,
      resultPath: 'createContactMethod.contactMethod'
    })
  },
  updateContactMethod({ state, dispatch }, contactMethod) {
    return dispatch('createItem', {
      item: contactMethod,
      state,
      addTo: ['contactMethods'],
      loader: 'contactMethod:update',
      mutation: updateContactMethodMutation,
      resultPath: 'updateContactMethod.contactMethod'
    })
  },
  deleteContactMethod({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['contactMethods'],
      loader: 'contactMethod:delete',
      mutation: deleteContactMethodMutation
    })
  }
}
